export default __webpack_public_path__ + "static/media/tooltip-gray.f5311c2c.svg";